import api, { ApiResponse } from './api';

export interface EpgAccess {
  id: number;
  user_id: number;
  server_name: string;
  server_ip: string;
  description: string | null;
  is_active: number;
  created_at: string;
  updated_at: string;
}

export interface EpgUrls {
  epgUrl: string;
  linearUrl: string;
  scheduleUrl: string;
}

export interface EpgGenerateResult {
  events: number;
  competitions: number;
  linearChannels: number;
  days: number;
}

export interface LinearGenerateResult {
  channels: number;
  programs: number;
}

export const epgService = {
  async getUrls(): Promise<EpgUrls> {
    const response = await api.get<ApiResponse<EpgUrls>>('/epg/urls');
    return response.data.data;
  },

  async listAccess(): Promise<EpgAccess[]> {
    const response = await api.get<ApiResponse<EpgAccess[]>>('/epg/access');
    return response.data.data;
  },

  async createAccess(data: { server_name: string; server_ip: string; description?: string }): Promise<EpgAccess> {
    const response = await api.post<ApiResponse<EpgAccess>>('/epg/access', data);
    return response.data.data;
  },

  async updateAccess(id: number, data: Partial<{ server_name: string; server_ip: string; description: string; is_active: boolean }>): Promise<EpgAccess> {
    const response = await api.put<ApiResponse<EpgAccess>>(`/epg/access/${id}`, data);
    return response.data.data;
  },

  async deleteAccess(id: number): Promise<void> {
    await api.delete(`/epg/access/${id}`);
  },

  async generateEpg(days?: number): Promise<EpgGenerateResult> {
    const response = await api.get<ApiResponse<EpgGenerateResult>>('/epg/generate', { params: { days } });
    return response.data.data;
  },

  async generateLinear(): Promise<LinearGenerateResult> {
    const response = await api.get<ApiResponse<LinearGenerateResult>>('/epg/generate-linear');
    return response.data.data;
  },

  async downloadEpg(days?: number): Promise<Blob> {
    const response = await api.get('/epg/download', { params: { days }, responseType: 'blob' });
    return response.data;
  },

  async downloadLinear(): Promise<Blob> {
    const response = await api.get('/epg/download-linear', { responseType: 'blob' });
    return response.data;
  },
};
